import { useState, useEffect } from "react";
import styled from "styled-components";

import SectionContainer from "../container/SectionContainer";
import { CellSelector, ColorV2, Text } from "@adoptaunabuelo/react-components";
import { UserScheme, User } from "client-v2";
import { State } from "../../redux";
import { useSelector } from "react-redux";
import { Check, Infinity, Mars, VenusIcon } from "lucide-react";

const CellContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
const Cell = styled.div<{ $isSelected: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 16px 18px;
	border-radius: 16px;
	box-shadow: 0px 0px 0px
		${(props) =>
			props.$isSelected
				? `2px ${ColorV2.border.primary}`
				: `1px ${ColorV2.border.neutralSoft}`};
	gap: 16px;
	background-color: ${(props) =>
		props.$isSelected ? ColorV2.border.primarySoft : "transparent"};
	cursor: pointer;
	&:hover {
		background-color: ${ColorV2.border.primarySoft};
		box-shadow: 0px 0px 0px 2px ${ColorV2.border.primary};
	}
`;
const CheckIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${ColorV2.surface.primary};
	border-radius: 24px;
	height: 24px;
	width: 24px;
`;

const GenderStep = (props: GenderStepProps) => {
	const translation = useSelector(
		(state: State) => state.location.translation,
	);
	const colors = {
		buttonBackground: ColorV2.surface.primary,
		buttonColor: "white",
		animation: ["#00315C", "#005AA8"],
	};

	const [badInput, setBadInput] = useState(false);
	const [gender, setGender] = useState<string | undefined>(undefined);
	const [loading, setLoading] = useState(false);
	const options = [
		{
			id: "male",
			title: "Hombre",
			icon: <Mars color={ColorV2.text.neutralHard} />,
		},
		{
			id: "female",
			title: "Mujer",
			icon: <VenusIcon color={ColorV2.text.neutralHard} />,
		},
		{
			id: "none",
			title: "Otro",
			icon: <Infinity color={ColorV2.text.neutralHard} />,
		},
	];

	const onGenderChange = (item: any) => {
		setGender(item.id);
		setBadInput(false);
	};

	const onNextClick = () => {
		if (gender) {
			setLoading(true);
			User.set(props.user.objectId, {
				gender: gender,
			})
				.then((result) => {
					setLoading(false);
					props.onFinish({ data: result.data });
				})
				.catch((error) => {
					setLoading(false);
					props.onFinish({ error: error.message });
				});
		} else {
			setBadInput(true);
		}
	};

	return (
		<SectionContainer
			title="Tu género"
			subtitle="Para que tu nuevo abuelo/a sepa algo más de ti."
			buttonProps={{
				style: {
					backgroundColor: colors.buttonBackground,
					color: colors.buttonColor,
				},
				loading: loading,
				children: translation.component_button_next,
				onClick: onNextClick,
			}}
		>
			<CellContainer>
				{options.map((item, index) => {
					const isSelected = item.id === gender;
					return (
						<Cell
							key={"gender-" + index}
							$isSelected={isSelected}
							onClick={() => onGenderChange(item)}
						>
							{item.icon}
							<Text
								style={{ display: "flex", flex: 1 }}
								type="p"
								weight="medium"
							>
								{item.title}
							</Text>
							{isSelected && (
								<CheckIcon>
									<Check
										color="white"
										height={16}
										width={16}
										strokeWidth={4}
									/>
								</CheckIcon>
							)}
						</Cell>
					);
				})}
			</CellContainer>
			{badInput && (
				<Text
					type="p"
					style={{
						marginTop: 12,
						color: ColorV2.text.redHard,
						fontSize: 14,
					}}
				>
					Debes seleccionar al menos una de las opciones.
				</Text>
			)}
		</SectionContainer>
	);
};
export default GenderStep;
export interface GenderStepProps {
	user: UserScheme;
	onFinish: (result: { data?: UserScheme; error?: string }) => void;
}
